import { Container } from '@/components';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Trans } from 'next-i18next';
import styles from './styles.module.scss';

export const OurMissionSection: FC = () => {
  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Box className={styles.body}>
          <Typography variant="h2" className={styles.title}>
            <Trans ns="about" i18nKey="ourMission.title" />
          </Typography>
          <Typography variant="subtitle1" className={styles.text}>
            <Trans ns="about" i18nKey="ourMission.text" />
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
